module.exports = __webpack_public_path__ + "static/media/room_map_black.fa6ccce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/room_map_black.png
// module id = 91
// module chunks = 0